module.exports = __webpack_public_path__ + "img/land-location.aa035509.svg";